module.exports = __webpack_public_path__ + "static/media/sj.14c3a512.svg";